import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { guardianNotificationsApi } from '../../services/api/guardianNotifications';
import { NotificationFilters } from '../../services/api/notifications';

export const useGuardianUnreadCount = () => {
  return useQuery({
    queryKey: ['guardian-notifications', 'unread-count'],
    queryFn: () => guardianNotificationsApi.getUnreadCount(),
    refetchInterval: 30000,
    staleTime: 20000,
  });
};

export const useGuardianNotifications = (filters?: NotificationFilters) => {
  return useQuery({
    queryKey: ['guardian-notifications', 'list', filters],
    queryFn: () => guardianNotificationsApi.getNotifications(filters),
  });
};

export const useGuardianMarkAsRead = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => guardianNotificationsApi.markAsRead(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['guardian-notifications'] });
    },
  });
};

export const useGuardianMarkAllAsRead = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => guardianNotificationsApi.markAllAsRead(),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['guardian-notifications'] });
    },
  });
};

export const useGuardianDeleteNotification = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => guardianNotificationsApi.deleteNotification(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['guardian-notifications'] });
    },
  });
};
